import { render, staticRenderFns } from "./PinBanner.vue?vue&type=template&id=e681e7ec&scoped=true&"
import script from "./PinBanner.vue?vue&type=script&lang=js&"
export * from "./PinBanner.vue?vue&type=script&lang=js&"
import style0 from "./PinBanner.vue?vue&type=style&index=0&id=e681e7ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e681e7ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
